export const ZODIAC_SIGNS = [
    { id: 'aries', nameRu: 'Овен', nameEn: 'Aries', symbol: '♈', element: 'fire', modality: 'cardinal', startMonth: 3, startDay: 21 },
    { id: 'taurus', nameRu: 'Телец', nameEn: 'Taurus', symbol: '♉', element: 'earth', modality: 'fixed', startMonth: 4, startDay: 20 },
    { id: 'gemini', nameRu: 'Близнецы', nameEn: 'Gemini', symbol: '♊', element: 'air', modality: 'mutable', startMonth: 5, startDay: 21 },
    { id: 'cancer', nameRu: 'Рак', nameEn: 'Cancer', symbol: '♋', element: 'water', modality: 'cardinal', startMonth: 6, startDay: 22 },
    { id: 'leo', nameRu: 'Лев', nameEn: 'Leo', symbol: '♌', element: 'fire', modality: 'fixed', startMonth: 7, startDay: 23 },
    { id: 'virgo', nameRu: 'Дева', nameEn: 'Virgo', symbol: '♍', element: 'earth', modality: 'mutable', startMonth: 8, startDay: 23 },
    { id: 'libra', nameRu: 'Весы', nameEn: 'Libra', symbol: '♎', element: 'air', modality: 'cardinal', startMonth: 9, startDay: 23 },
    { id: 'scorpio', nameRu: 'Скорпион', nameEn: 'Scorpio', symbol: '♏', element: 'water', modality: 'fixed', startMonth: 10, startDay: 23 },
    { id: 'sagittarius', nameRu: 'Стрелец', nameEn: 'Sagittarius', symbol: '♐', element: 'fire', modality: 'mutable', startMonth: 11, startDay: 22 },
    { id: 'capricorn', nameRu: 'Козерог', nameEn: 'Capricorn', symbol: '♑', element: 'earth', modality: 'cardinal', startMonth: 12, startDay: 22 },
    { id: 'aquarius', nameRu: 'Водолей', nameEn: 'Aquarius', symbol: '♒', element: 'air', modality: 'fixed', startMonth: 1, startDay: 20 },
    { id: 'pisces', nameRu: 'Рыбы', nameEn: 'Pisces', symbol: '♓', element: 'water', modality: 'mutable', startMonth: 2, startDay: 19 },
];
export const PLANETS = [
    { id: 'sun', nameRu: 'Солнце', nameEn: 'Sun', symbol: '☉' },
    { id: 'moon', nameRu: 'Луна', nameEn: 'Moon', symbol: '☽' },
    { id: 'mercury', nameRu: 'Меркурий', nameEn: 'Mercury', symbol: '☿' },
    { id: 'venus', nameRu: 'Венера', nameEn: 'Venus', symbol: '♀' },
    { id: 'mars', nameRu: 'Марс', nameEn: 'Mars', symbol: '♂' },
    { id: 'jupiter', nameRu: 'Юпитер', nameEn: 'Jupiter', symbol: '♃' },
    { id: 'saturn', nameRu: 'Сатурн', nameEn: 'Saturn', symbol: '♄' },
    { id: 'uranus', nameRu: 'Уран', nameEn: 'Uranus', symbol: '♅' },
    { id: 'neptune', nameRu: 'Нептун', nameEn: 'Neptune', symbol: '♆' },
    { id: 'pluto', nameRu: 'Плутон', nameEn: 'Pluto', symbol: '♇' },
];
export const HOUSES = [
    { number: 1, themeRu: 'Личность и тело', themeEn: 'Self and body' },
    { number: 2, themeRu: 'Ресурсы и ценности', themeEn: 'Resources and values' },
    { number: 3, themeRu: 'Общение и обучение', themeEn: 'Communication and learning' },
    { number: 4, themeRu: 'Дом и корни', themeEn: 'Home and roots' },
    { number: 5, themeRu: 'Творчество и романтика', themeEn: 'Creativity and romance' },
    { number: 6, themeRu: 'Здоровье и привычки', themeEn: 'Health and habits' },
    { number: 7, themeRu: 'Партнёрство', themeEn: 'Partnership' },
    { number: 8, themeRu: 'Глубина и трансформации', themeEn: 'Depth and transformation' },
    { number: 9, themeRu: 'Смыслы и путешествия', themeEn: 'Meaning and journeys' },
    { number: 10, themeRu: 'Карьера и репутация', themeEn: 'Career and reputation' },
    { number: 11, themeRu: 'Друзья и мечты', themeEn: 'Friends and dreams' },
    { number: 12, themeRu: 'Тайны и внутренний мир', themeEn: 'Secrets and inner world' },
];
export const ASPECTS = [
    { id: 'conjunction', nameRu: 'Соединение', nameEn: 'Conjunction', angleDegrees: 0, defaultOrbDegrees: 8, vibe: 'neutral' },
    { id: 'sextile', nameRu: 'Секстиль', nameEn: 'Sextile', angleDegrees: 60, defaultOrbDegrees: 4, vibe: 'supportive' },
    { id: 'square', nameRu: 'Квадрат', nameEn: 'Square', angleDegrees: 90, defaultOrbDegrees: 6, vibe: 'tension' },
    { id: 'trine', nameRu: 'Трин', nameEn: 'Trine', angleDegrees: 120, defaultOrbDegrees: 6, vibe: 'supportive' },
    { id: 'opposition', nameRu: 'Оппозиция', nameEn: 'Opposition', angleDegrees: 180, defaultOrbDegrees: 8, vibe: 'tension' },
];
/** Sun-sign by Gregorian month/day. Year ignored — boundary days slot to the start sign of that range. */
export function getSunSign(month, day) {
    if ((month === 3 && day >= 21) || (month === 4 && day <= 19))
        return 'aries';
    if ((month === 4 && day >= 20) || (month === 5 && day <= 20))
        return 'taurus';
    if ((month === 5 && day >= 21) || (month === 6 && day <= 21))
        return 'gemini';
    if ((month === 6 && day >= 22) || (month === 7 && day <= 22))
        return 'cancer';
    if ((month === 7 && day >= 23) || (month === 8 && day <= 22))
        return 'leo';
    if ((month === 8 && day >= 23) || (month === 9 && day <= 22))
        return 'virgo';
    if ((month === 9 && day >= 23) || (month === 10 && day <= 22))
        return 'libra';
    if ((month === 10 && day >= 23) || (month === 11 && day <= 21))
        return 'scorpio';
    if ((month === 11 && day >= 22) || (month === 12 && day <= 21))
        return 'sagittarius';
    if ((month === 12 && day >= 22) || (month === 1 && day <= 19))
        return 'capricorn';
    if ((month === 1 && day >= 20) || (month === 2 && day <= 18))
        return 'aquarius';
    return 'pisces';
}
//# sourceMappingURL=constants.js.map